/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CreateDealDTO,
  DealArrayDTO,
  DealMerchantsResponseDTO,
  DealsListResponseDTO,
  InDealDTO,
  OutDealDTO
} from "../models";
import {
  CreateDealDTOFromJSON,
  CreateDealDTOToJSON,
  DealArrayDTOFromJSON,
  DealArrayDTOToJSON,
  DealMerchantsResponseDTOFromJSON,
  DealMerchantsResponseDTOToJSON,
  DealsListResponseDTOFromJSON,
  DealsListResponseDTOToJSON,
  InDealDTOFromJSON,
  InDealDTOToJSON,
  OutDealDTOFromJSON,
  OutDealDTOToJSON
} from "../models";

export interface BulkDeleteDealsRequest {
  dealIds: string;
}

export interface BulkPatchRequest {
  dealArrayDTO: DealArrayDTO;
}

export interface DeleteDealRequest {
  dealId: number;
}

export interface FindAllDealsByFiltersRequest {
  skip: number;
  take: number;
  platformId?: number;
  sponsored?: number;
  filters?: string;
  searchQuery?: string;
  merchantFilters?: string;
  orderBy?: string;
  orderByDirection?: string;
  externalDealFilters?: string;
}

export interface GetAllDealsExtendedRequest {
  skip: number;
  take: number;
  isLive?: string;
  platformId?: number;
  createdBy?: GetAllDealsExtendedCreatedByEnum;
  filters?: string;
  searchQuery?: string;
  merchantFilters?: string;
  externalDealFilters?: string;
  ean?: string;
  sponsored?: number;
}

export interface GetDealByIdRequest {
  dealId: number;
}

export interface GetDealCountRequest {
  platformId: number;
  filters?: string;
  merchantFilters?: string;
}

export interface GetDealsByIdsRequest {
  ids: string;
  platformId: number;
  labelFilter?: string;
}

export interface GetMerchantWithDealCountRequest {
  take?: number;
  platformId?: number;
  dealIds?: string;
  searchQuery?: string;
}

export interface PostDealRequest {
  createDealDTO: CreateDealDTO;
}

export interface PutDealRequest {
  dealId: number;
  inDealDTO: InDealDTO;
}

/**
 *
 */
export class DealsApi extends runtime.BaseAPI {
  /**
   */
  async bulkDeleteDealsRaw(
    requestParameters: BulkDeleteDealsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.dealIds === null || requestParameters.dealIds === undefined) {
      throw new runtime.RequiredError(
        "dealIds",
        "Required parameter requestParameters.dealIds was null or undefined when calling bulkDeleteDeals."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.dealIds !== undefined) {
      queryParameters["dealIds"] = requestParameters.dealIds;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/deals/bulk`,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async bulkDeleteDeals(
    requestParameters: BulkDeleteDealsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.bulkDeleteDealsRaw(requestParameters, initOverrides);
  }

  /**
   */
  async bulkPatchRaw(
    requestParameters: BulkPatchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.dealArrayDTO === null || requestParameters.dealArrayDTO === undefined) {
      throw new runtime.RequiredError(
        "dealArrayDTO",
        "Required parameter requestParameters.dealArrayDTO was null or undefined when calling bulkPatch."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/deals/bulk`,
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: DealArrayDTOToJSON(requestParameters.dealArrayDTO)
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async bulkPatch(
    requestParameters: BulkPatchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.bulkPatchRaw(requestParameters, initOverrides);
  }

  /**
   */
  async deleteDealRaw(
    requestParameters: DeleteDealRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<boolean>> {
    if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
      throw new runtime.RequiredError(
        "dealId",
        "Required parameter requestParameters.dealId was null or undefined when calling deleteDeal."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/deals/{dealId}`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<boolean>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async deleteDeal(
    requestParameters: DeleteDealRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<boolean> {
    const response = await this.deleteDealRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async findAllDealsByFiltersRaw(
    requestParameters: FindAllDealsByFiltersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DealsListResponseDTO>> {
    if (requestParameters.skip === null || requestParameters.skip === undefined) {
      throw new runtime.RequiredError(
        "skip",
        "Required parameter requestParameters.skip was null or undefined when calling findAllDealsByFilters."
      );
    }

    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling findAllDealsByFilters."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.skip !== undefined) {
      queryParameters["skip"] = requestParameters.skip;
    }

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.sponsored !== undefined) {
      queryParameters["sponsored"] = requestParameters.sponsored;
    }

    if (requestParameters.filters !== undefined) {
      queryParameters["filters"] = requestParameters.filters;
    }

    if (requestParameters.searchQuery !== undefined) {
      queryParameters["searchQuery"] = requestParameters.searchQuery;
    }

    if (requestParameters.merchantFilters !== undefined) {
      queryParameters["merchantFilters"] = requestParameters.merchantFilters;
    }

    if (requestParameters.orderBy !== undefined) {
      queryParameters["orderBy"] = requestParameters.orderBy;
    }

    if (requestParameters.orderByDirection !== undefined) {
      queryParameters["orderByDirection"] = requestParameters.orderByDirection;
    }

    if (requestParameters.externalDealFilters !== undefined) {
      queryParameters["externalDealFilters"] = requestParameters.externalDealFilters;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/deals`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => DealsListResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async findAllDealsByFilters(
    requestParameters: FindAllDealsByFiltersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DealsListResponseDTO> {
    const response = await this.findAllDealsByFiltersRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async getAllDealsExtendedRaw(
    requestParameters: GetAllDealsExtendedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DealsListResponseDTO>> {
    if (requestParameters.skip === null || requestParameters.skip === undefined) {
      throw new runtime.RequiredError(
        "skip",
        "Required parameter requestParameters.skip was null or undefined when calling getAllDealsExtended."
      );
    }

    if (requestParameters.take === null || requestParameters.take === undefined) {
      throw new runtime.RequiredError(
        "take",
        "Required parameter requestParameters.take was null or undefined when calling getAllDealsExtended."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.skip !== undefined) {
      queryParameters["skip"] = requestParameters.skip;
    }

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.isLive !== undefined) {
      queryParameters["isLive"] = requestParameters.isLive;
    }

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.createdBy !== undefined) {
      queryParameters["createdBy"] = requestParameters.createdBy;
    }

    if (requestParameters.filters !== undefined) {
      queryParameters["filters"] = requestParameters.filters;
    }

    if (requestParameters.searchQuery !== undefined) {
      queryParameters["searchQuery"] = requestParameters.searchQuery;
    }

    if (requestParameters.merchantFilters !== undefined) {
      queryParameters["merchantFilters"] = requestParameters.merchantFilters;
    }

    if (requestParameters.externalDealFilters !== undefined) {
      queryParameters["externalDealFilters"] = requestParameters.externalDealFilters;
    }

    if (requestParameters.ean !== undefined) {
      queryParameters["ean"] = requestParameters.ean;
    }

    if (requestParameters.sponsored !== undefined) {
      queryParameters["sponsored"] = requestParameters.sponsored;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/deals/extended`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => DealsListResponseDTOFromJSON(jsonValue));
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async getAllDealsExtended(
    requestParameters: GetAllDealsExtendedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DealsListResponseDTO> {
    const response = await this.getAllDealsExtendedRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getDealByIdRaw(
    requestParameters: GetDealByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutDealDTO>> {
    if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
      throw new runtime.RequiredError(
        "dealId",
        "Required parameter requestParameters.dealId was null or undefined when calling getDealById."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/deals/{dealId}`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutDealDTOFromJSON(jsonValue));
  }

  /**
   */
  async getDealById(
    requestParameters: GetDealByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutDealDTO> {
    const response = await this.getDealByIdRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getDealCountRaw(
    requestParameters: GetDealCountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<number>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling getDealCount."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.filters !== undefined) {
      queryParameters["filters"] = requestParameters.filters;
    }

    if (requestParameters.merchantFilters !== undefined) {
      queryParameters["merchantFilters"] = requestParameters.merchantFilters;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/deals/count`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<number>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   */
  async getDealCount(
    requestParameters: GetDealCountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<number> {
    const response = await this.getDealCountRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getDealsByIdsRaw(
    requestParameters: GetDealsByIdsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DealsListResponseDTO>> {
    if (requestParameters.ids === null || requestParameters.ids === undefined) {
      throw new runtime.RequiredError(
        "ids",
        "Required parameter requestParameters.ids was null or undefined when calling getDealsByIds."
      );
    }

    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling getDealsByIds."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.ids !== undefined) {
      queryParameters["ids"] = requestParameters.ids;
    }

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.labelFilter !== undefined) {
      queryParameters["labelFilter"] = requestParameters.labelFilter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/deals/bulk`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => DealsListResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async getDealsByIds(
    requestParameters: GetDealsByIdsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DealsListResponseDTO> {
    const response = await this.getDealsByIdsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getMerchantWithDealCountRaw(
    requestParameters: GetMerchantWithDealCountRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<DealMerchantsResponseDTO>> {
    const queryParameters: any = {};

    if (requestParameters.take !== undefined) {
      queryParameters["take"] = requestParameters.take;
    }

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    if (requestParameters.dealIds !== undefined) {
      queryParameters["dealIds"] = requestParameters.dealIds;
    }

    if (requestParameters.searchQuery !== undefined) {
      queryParameters["searchQuery"] = requestParameters.searchQuery;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/deals/merchants`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => DealMerchantsResponseDTOFromJSON(jsonValue));
  }

  /**
   */
  async getMerchantWithDealCount(
    requestParameters: GetMerchantWithDealCountRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<DealMerchantsResponseDTO> {
    const response = await this.getMerchantWithDealCountRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async postDealRaw(
    requestParameters: PostDealRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutDealDTO>> {
    if (requestParameters.createDealDTO === null || requestParameters.createDealDTO === undefined) {
      throw new runtime.RequiredError(
        "createDealDTO",
        "Required parameter requestParameters.createDealDTO was null or undefined when calling postDeal."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/deals`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateDealDTOToJSON(requestParameters.createDealDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutDealDTOFromJSON(jsonValue));
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async postDeal(
    requestParameters: PostDealRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutDealDTO> {
    const response = await this.postDealRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async putDealRaw(
    requestParameters: PutDealRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<OutDealDTO>> {
    if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
      throw new runtime.RequiredError(
        "dealId",
        "Required parameter requestParameters.dealId was null or undefined when calling putDeal."
      );
    }

    if (requestParameters.inDealDTO === null || requestParameters.inDealDTO === undefined) {
      throw new runtime.RequiredError(
        "inDealDTO",
        "Required parameter requestParameters.inDealDTO was null or undefined when calling putDeal."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/deals/{dealId}`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: InDealDTOToJSON(requestParameters.inDealDTO)
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => OutDealDTOFromJSON(jsonValue));
  }

  /**
   * This request can be accessed with an ApiKey.
   * ApiKey
   */
  async putDeal(
    requestParameters: PutDealRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<OutDealDTO> {
    const response = await this.putDealRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const GetAllDealsExtendedCreatedByEnum = {
  API: "API",
  DASHBOARD: "DASHBOARD",
  UNKNOWN: "UNKNOWN"
} as const;
export type GetAllDealsExtendedCreatedByEnum =
  typeof GetAllDealsExtendedCreatedByEnum[keyof typeof GetAllDealsExtendedCreatedByEnum];
